// @flow
import * as React from 'react';
import Modal from 'react-modal';
import cx from 'classnames';

import DeliveryModalContainer from 'chat_v2/components/DeliveryModalContainer';
import ReactionSummaryModal from 'chat_v2/components/ReactionSummaryModal';
import ErrorReporter from 'app/components/ErrorReporter';
import Glyph from 'components/Glyph';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';

export type Props = {
  avatar: React.Element<any>,
  targetTitle: string,
  targetDescription: ?string,
  canViewDeliveryInformation: boolean,
  streamUuid: string,
  messageUuid: string,
  reactions: ?(ReactionGQL[]),
  urgent?: boolean,
};

type State = {
  showModal: boolean,
};

class AnnouncementMessageItemHeader extends React.Component<Props, State> {
  state = {
    showModal: false,
  };

  handleRequestHide = () => {
    this.setState({ showModal: false });
  };

  renderDeliveryModal() {
    const { streamUuid, messageUuid } = this.props;

    if (!streamUuid) {
      return (
        <ErrorReporter error="AnnouncementMessageItemHeader - tried to render delivery summary link without streamUuid" />
      );
    } else if (!messageUuid) {
      return (
        <ErrorReporter error="AnnouncementMessageItemHeader - tried to render delivery summary link without messageUuid" />
      );
    }

    return (
      <DeliveryModalContainer
        source={{
          type: 'stream',
          threadUuid: streamUuid,
          messageUuid,
        }}
        onRequestHide={this.handleRequestHide}
      />
    );
  }

  renderReactionsModal(reactions: ReactionGQL[]) {
    return <ReactionSummaryModal reactions={reactions} onRequestHide={this.handleRequestHide} />;
  }

  render() {
    const component = (options: { showCarat: boolean }) => (
      <MediaObject
        center
        gutter="xxsmall"
        className={cx(
          'AnnouncementMessageItem-head',
          this.props.urgent && 'AnnouncementMessageItem-head--urgent'
        )}>
        {this.props.avatar}
        <MediaObject figure="right" center>
          <div className="AnnouncementMessageItem-head-classInfo">
            <Text weight="semibold" color="chalkboard" truncate>
              {this.props.targetTitle}
            </Text>
            <Text color="graphite" truncate>
              {this.props.targetDescription}
            </Text>
          </div>
          {options.showCarat && <Glyph name="chevron-right" color="mascot" data-test="carat" />}
        </MediaObject>
      </MediaObject>
    );

    if (this.props.canViewDeliveryInformation) {
      return (
        <React.Fragment>
          <Modal isOpen={this.state.showModal}>{this.renderDeliveryModal()}</Modal>
          <Link
            onClick={() => this.setState({ showModal: true })}
            data-test="header-click-area"
            eventKey="message_cell.delivery_summary.click">
            {component({ showCarat: true })}
          </Link>
        </React.Fragment>
      );
    }

    const { reactions } = this.props;

    if (reactions && reactions.length) {
      return (
        <React.Fragment>
          <Modal isOpen={this.state.showModal}>{this.renderReactionsModal(reactions)}</Modal>
          <Link
            onClick={() => this.setState({ showModal: true })}
            data-test="header-click-area"
            eventKey="message_cell.reaction_summary.click">
            {component({ showCarat: true })}
          </Link>
        </React.Fragment>
      );
    }

    return component({ showCarat: false });
  }
}
export default AnnouncementMessageItemHeader;
